<template>
  <div class="row mt-4">
    <div class="col-md-4 d-md-none" @click.stop.prevent="setClientType(1)">
      <img
        src="/assets/img/NWW_signal_new.png"
        style="max-width: 100%; max-height: 100%; margin: 0 auto"
      />
    </div>
    <div class="col-md-8 d-flex align-items-stretch">
      <div
        class="ang-card card-icon-bg card-icon-bg-primary o-hidden mb-30 text-center"
      >
        <!---->
        <!---->
        <div class="ang-card-body d-flex flex-column">
          <h5 class="ang-card-title">
            Dlaczego warto skorzystać z ubezpieczenia od Następstw
            Nieszczęśliwych Wypadków dla dzieci i młodzieży?
          </h5>
          <div class="content p-3">
            <ul style="list-style: disc" class="pl-5">
              <li>
                Jest to ochrona na wysokie sumy ubezpieczenia, np. uszczerbek na
                zdrowiu nawet do 150 000 zł.
              </li>
              <li>
                Można ubezpieczyć już malutkie dzieci od 6 miesiąca życia aż do
                26 roku życia.
              </li>
              <li>
                Działa przez cały rok, 24/7, na terenie całego świata (w tym
                również w okresie wakacyjnym).
              </li>
              <li>
                Uwzględnia koszty pobytu w szpitalu w wyniku wypadku lub choroby
                już od pierwszego dnia pobytu.
              </li>
              <li>
                Obejmuje refundację kosztów leczenia i rehabilitacji oraz koszty
                odbudowy zębów stałych.
              </li>
              <li>
                Otrzymujesz zniżkę 20% przy ubezpieczeniu kolejnych dzieci w
                rodzinie.
              </li>
            </ul>
            <div class="flex">
              <p class="ang-card-title mt-4 pt-2 mb-0">
                Wybierz pakiet najlepszy dla Twojego dziecka.
              </p>
              <div class="d-none d-lg-block">
                <a
                  href="https://angfinanse.pl/ubezpieczenia_oferta/Ulotka_NNW_dla_dzieci.pdf"
                  target="_blank"
                  class="btn ang-button ang-btn-lg _bg_color3 mt-4 ml-5 text-nowrap"
                  >POZNAJ SZCZEGÓŁY
                </a>
              </div>
            </div>
            <a
              href="https://angfinanse.pl/ubezpieczenia_oferta/Ulotka_NNW_dla_dzieci.pdf"
              target="_blank"
              class="btn ang-button ang-btn-lg _bg_color3 mt-4 ml-5 text-nowrap d-lg-none"
              >POZNAJ SZCZEGÓŁY
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-md-4 d-none d-md-block"
      @click.stop.prevent="setClientType(1)"
    >
      <img
        src="/assets/img/NWW_signal_new.png"
        style="max-width: 100%; max-height: 100%"
      />
    </div>
    <p class="h5 mt-6 text-center">
      Zanim dokonasz zakupu ubezpieczenia wypełnij formularz i zapoznaj się z
      informacją o przetwarzaniu Twoich danych
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
